var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _rect3, _rect4, _rect5, _rect6, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15AcPowerManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 829,
    y: 700.84,
    width: 67,
    height: 32.16,
    fill: "url(#paint0_linear_1989_5602)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M839.72 671.36H885.28L896 700.84H829L839.72 671.36Z",
    fill: "url(#paint1_linear_1989_5602)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M857.14 690.566L862.053 682.973L867.86 690.566H857.14Z",
    fill: "#FFCE70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M857.14 690.567H867.86",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M829 701.287H896",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M829 732.553H896",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M895.553 701.733V733",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M829.447 701.733V733",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 839.72,
    y: 705.307,
    width: 45.56,
    height: 11.6133,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M844.186 710.369C844.186 710.04 844.453 709.773 844.782 709.773H850.737V713.347H844.782C844.453 713.347 844.186 713.08 844.186 712.751V710.369Z",
    fill: "#2FD60A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.293 710.369C843.293 709.546 843.96 708.88 844.782 708.88H853.12C853.942 708.88 854.609 709.546 854.609 710.369V712.751C854.609 713.573 853.942 714.24 853.12 714.24H844.782C843.96 714.24 843.293 713.573 843.293 712.751V710.369ZM844.782 709.475C844.289 709.475 843.889 709.875 843.889 710.369V712.751C843.889 713.244 844.289 713.644 844.782 713.644H853.12C853.613 713.644 854.013 713.244 854.013 712.751V710.369C854.013 709.875 853.613 709.475 853.12 709.475H844.782Z",
    fill: "#2FD60A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 860.267,
    y: 707.987,
    width: 0.893333,
    height: 0.893333,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 860.267,
    y: 709.773,
    width: 0.893333,
    height: 0.893333,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 860.267,
    y: 711.56,
    width: 0.893333,
    height: 0.893333,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 860.267,
    y: 713.346,
    width: 0.893333,
    height: 0.893333,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 882.154,
    cy: 708.433,
    r: 1.34,
    fill: "#FF4949"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 833.721,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 836.018,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.315,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.612,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.91,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845.207,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.504,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.801,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852.098,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.395,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.692,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 858.99,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.287,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.584,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 865.881,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.178,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.475,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.772,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.07,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.367,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.664,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.961,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 884.259,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.555,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.852,
    y: 721.642,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 833.721,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 836.018,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.315,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.612,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.91,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845.207,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.504,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.801,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852.098,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.395,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.692,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 858.99,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.287,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.584,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 865.881,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.178,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.475,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.772,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.07,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.367,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.664,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.961,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 884.259,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.555,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.852,
    y: 726.236,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 833.721,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 836.018,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.315,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.612,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.91,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845.207,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.504,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.801,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852.098,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.395,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.692,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 858.99,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.287,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.584,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 865.881,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.178,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.475,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.772,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.07,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.367,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.664,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.961,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 884.259,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.555,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.852,
    y: 723.939,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 832.573,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.87,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837.167,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.464,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.762,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.059,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.356,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.653,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.95,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.248,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855.544,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857.842,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.139,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.437,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.733,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 867.03,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.327,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.625,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.922,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.219,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.516,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.813,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 883.111,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.407,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 887.705,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.002,
    y: 720.493,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 832.573,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.87,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837.167,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.464,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.762,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.059,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.356,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.653,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.95,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.248,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855.544,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857.842,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.139,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.437,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.733,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 867.03,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.327,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.625,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.922,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.219,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.516,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.813,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 883.111,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.407,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 887.705,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.002,
    y: 727.385,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 832.573,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.87,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837.167,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.464,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.762,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.059,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.356,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.653,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.95,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.248,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855.544,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857.842,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.139,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.437,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.733,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 867.03,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.327,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.625,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.922,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.219,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.516,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.813,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 883.111,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.407,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 887.705,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.002,
    y: 722.79,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 832.573,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.87,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837.167,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.464,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.762,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.059,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.356,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.653,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.95,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.248,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855.544,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857.842,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.139,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.437,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.733,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 867.03,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.327,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.625,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.922,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.219,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.516,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.813,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 883.111,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.407,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 887.705,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.002,
    y: 725.087,
    width: 1.14857,
    height: 1.14857,
    fill: "#18171E"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.393 686.1L862.71 689.01L861.333 688.092L860.267 689.227L859.867 689.027L860.987 686.788L862.29 687.656L862.979 685.934L863.393 686.1Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_5602",
    x1: 891.533,
    y1: 700.84,
    x2: 835.253,
    y2: 733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_5602",
    x1: 862.5,
    y1: 671.36,
    x2: 862.5,
    y2: 700.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F475E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15AcPowerManagement);
export default __webpack_public_path__ + "static/media/15ACPowerManagement.6f32b4410ce7396784ceb2e54a51941d.svg";
export { ForwardRef as ReactComponent };